// flow
import React, { Component } from 'react'
import Helmet from 'react-helmet'
import { connect } from 'react-redux'
import { User } from '../../types'
import { fetchOffers } from '../../actions/user'
import Blockquote from '../../components/Blockquote'
import Offer from './components/Offer'

type Props = {
  user: User,
  offers: Array<Object>,
  fetchOffers: Function
}

class UserOffers extends Component {
  componentDidMount() {
    this.props.fetchOffers(this.props.user.id)
  }

  props: Props

  render() {
    return (
      <div>
        <Helmet title="Offers" />
        <Blockquote style={{ marginBottom: '2rem' }}>
          Keep track of your home offers as they move through our pipeline.
        </Blockquote>
        {this.props.offers.map((offer) => (
          <Offer key={offer.id} offer={offer} />
        ))}
      </div>
    )
  }
}

export default connect(
  (state) => ({
    user: state.session.currentUser,
    offers: state.user.offers
  }),
  {
    fetchOffers
  }
)(UserOffers)



// WEBPACK FOOTER //
// ./src/views/UserOffers/index.js